import { apiFetch } from "./http";

// Staff — müşterinin kendi org'una bağlı panel kullanıcıları.
export type Staff = {
  id: number;
  email: string;
  full_name: string;
  role: string;
  org_id: number | null;
  is_active: boolean;
  created_at: string;
};

export async function listStaff(): Promise<Staff[]> {
  const res = await apiFetch("/api/v1/staff");
  if (!res.ok) throw new Error(`listStaff: HTTP ${res.status}`);
  const data = (await res.json()) as { staff: Staff[] | null };
  return data.staff ?? [];
}

export async function createStaff(input: { email: string; password: string; full_name: string }): Promise<Staff> {
  const res = await apiFetch("/api/v1/staff", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

export async function updateStaff(id: number, patch: { full_name?: string; is_active?: boolean }): Promise<Staff> {
  const res = await apiFetch(`/api/v1/staff/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

export async function deleteStaff(id: number): Promise<void> {
  const res = await apiFetch(`/api/v1/staff/${id}`, { method: "DELETE" });
  if (!res.ok && res.status !== 404) throw new Error(`deleteStaff: HTTP ${res.status}`);
}
